import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { _modal } from './_modal'
import { academicyears } from './academicyears'
import { account } from './account'
import { announcements } from './announcements'
import { appupdate } from './appupdate'
import { assessment } from './assessment'
import { auth } from './auth'
import { classperiods } from './classperiods'
import { classrooms } from './classrooms'
import { loom } from './loom'
import { manifest } from './manifest'
import { mentordashboard } from './mentordashboard'
import { myartifacts } from './myartifacts'
import { mycourses } from './mycourses'
import { myquests } from './myquests'
import { mystudents } from './mystudents'
import { notebook } from './notebook'
import { organization } from './organization'
import { policies } from './policies'
import { profile } from './profile'
import { studentprofile } from './studentprofile'
import { unsavedwork } from './unsavedwork'
import { users } from './users'
import { usercourses } from './usercourses'

// TODO: remove currentActivity completely once transition to Quest Upgrades is completes

const appReducer = history =>
  combineReducers({
    router: connectRouter(history),
    _modal,
    academicyears,
    account,
    announcements,
    appupdate,
    assessment,
    auth,
    classperiods,
    classrooms,
    loom,
    manifest,
    mentordashboard,
    myartifacts,
    mycourses,
    myquests,
    mystudents,
    notebook,
    organization,
    policies,
    profile,
    studentprofile,
    unsavedwork,
    users,
    usercourses
  })

export default appReducer

// https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store/35641992#35641992
/*
export default (state, action) => {
  // super important, otherwise we got in weird states where
  // users see last logged-in users' stuff
  if (action.type === 'LOGOUT_USER') {
    state = undefined
  }

  return appReducer(state, action)
}

 */
